import { render, staticRenderFns } from "./qualifapplyInitList.vue?vue&type=template&id=54d1c15a&scoped=true"
import script from "./qualifapplyInitList.vue?vue&type=script&lang=js"
export * from "./qualifapplyInitList.vue?vue&type=script&lang=js"
import style0 from "./qualifapplyInitList.vue?vue&type=style&index=0&id=54d1c15a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d1c15a",
  null
  
)

export default component.exports